import { defineStore } from 'pinia';

export const useCommStore = defineStore('common', {
  state: () => {
    return {
      currentPath: ''
    };
  },
  actions: {
    setCurrentPath(path) {
      this.currentPath = path;
    }
  },
  getters: {
    doubleCount: (state) => state.count * 2
  }
});